import { render, staticRenderFns } from "./SectionPostsSlider.vue?vue&type=template&id=50001f80&"
import script from "./SectionPostsSlider.vue?vue&type=script&lang=js&"
export * from "./SectionPostsSlider.vue?vue&type=script&lang=js&"
import style0 from "./SectionPostsSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResponsiveImageStrapi: require('/home/northbankcm/public_html/frontend/components/modules/ResponsiveImageStrapi.vue').default})
